<template>
  <div>
    <breadcrumbs
      :breadcrumb-items="breadcrumbItems"
    />
    <UserToolbar
      v-if="account && Object.keys(account).length !== 0 && shouldShowToolbar()"
      :account="account"
    />

    <GoogleAdsForm
      :google-ad="newGoogleAd"
      :type="formType"
      @switch-to-edit="switchToEdit"
    />
  </div>
</template>

<script>
import { isOfferWallOperator } from '@/auth/roles'
import useJwt from '@/auth/jwt/useJwt'
import Breadcrumbs from '@/views/ui/breadcrumbs/Breadcrumbs.vue'
import UserToolbar from '@/views/dashboard/users/UserToolbar.vue'
import { getUserData } from '@/auth/utils'
import GoogleAdsForm from './GoogleAdsForm.vue'

function isOfferWallOperatorUser() {
  return isOfferWallOperator(getUserData())
}

export default {
  components: {
    GoogleAdsForm,
    Breadcrumbs,
    UserToolbar,
  },
  data() {
    return {
      breadcrumbItems: [],
      account: {},
      formType: 'create',
      newGoogleAd: {
        title: '',
        provider_id: '',
        partner_rate: '',
        user_id: this.$route.params.userId,
        status: 'active',
        config: {
          enableModal: true,
          enableInImage: false,
          enableFallback: true,
          adType: 'gpt',
          timerDuration: 5,
          showDelay: 2000,
          blurOffset: 0,
          frequencyCappingHours: 2,
          hideIfNoAd: true,
          logo: 'https://nakonu.com/wp-content/uploads/2022/11/logo.png',
          gpt: {
            adUnitPath: '/22247219933,8448570/Chordzaa_Adx/Rewarded_Phoenix',
            adUnitPathRewarded: '/22247219933,8448570/Phoenix/Phoenix_Rewarded_OoP',
            adSize: [
              [728, 346], [240, 400], [970, 250], [160, 600], [750, 300],
              [970, 280], [750, 200], [768, 1024], [1024, 768], [336, 280],
              [750, 100], [200, 200], [728, 250], [970, 90], [250, 346],
              [120, 240], [320, 480], [247, 245], [300, 600], [250, 250],
              [300, 250],
            ],
          },
          adsense: {
            adClient: null,
            adSlot: null,
            adSize: [300, 250],
          },
          inImage: {
            contentSelector: '',
            maxOverlap: 30,
            frequencyCappingHours: 2,
            adSize: [[300, 250]],
            slots: [''],
          },
          texts: {
            title: 'Уважаемый читатель',
            message: 'Пожалуйста, посмотрите короткую рекламу,<br> чтобы поддержать сайт.',
            continueBtn: 'Продолжить',
            backBtn: 'Назад',
            timerText: 'Вознаграждение через {seconds} с',
            adLoading: 'Загрузка рекламы...',
            pleaseWait: 'Пожалуйста, подождите',
          },
          textsOptions: [],
          styles: {
            title: { color: '#1a1a1a', fontSize: ['20px', '14px'] },
            message: { color: '#555555', fontSize: ['18px', '14px'] },
            timer: { color: '#6c757d', fontSize: ['14px', '14px'] },
            button: {
              color: '#ffffff',
              backgroundColor: '#1976d2',
              hoverBackgroundColor: '#1565c0',
              fontSize: ['16px', '16px'],
            },
          },
        },
      },
    }
  },
  created() {
    this.getUserData()
  },
  methods: {
    isOfferWallOperatorUser,
    shouldShowToolbar() {
      if (!isOfferWallOperatorUser()) return true
      const currentUser = getUserData()
      return String(this.$route.params.userId) === String(currentUser?.id)
    },
    setBreabcrumbs() {
      if (this.$route.params.userId !== undefined) {
        this.breadcrumbItems = [
          {
            text: 'users',
            to: '/users',
          },
          {
            text: this.account.name,
            to: `/users/${this.$route.params.userId}`,
          },
          {
            text: this.$t('google_ads.list'),
            to: `/users/${this.$route.params.userId}/offerwall`,
          },
          {
            text: this.$t('google_ads.new_ad'),
            active: true,
          },
        ]
      } else {
        this.breadcrumbItems = [
          {
            text: this.$t('google_ads.list'),
            active: true,
          },
        ]
      }
    },
    async getUserData() {
      const responseData = await useJwt.getUser(this.$route.params.userId)
      this.account = responseData.data.account || []
      this.setBreabcrumbs()
    },
    switchToEdit() {
      this.formType = 'edit'
      if (this.newGoogleAd._id) {
        this.$router.push(`/users/${this.$route.params.userId}/offerwall/${this.newGoogleAd._id}/edit`)
      }
    },
  },
}
</script>
